import { useAtomValue } from 'jotai';
import { useUserTDK } from '../shared/use-user-tdk';
import { $CurrentAvailableUserOrNull } from '@user/shared/atoms/current-user';
import { CommonPageOGCard, EOGType, ICommonPageOGCardProps, IOGImage } from '@lemon8/web-app-shared/ssr';
import { loadable } from 'jotai/utils';
import { $SEOCurrentTraffic } from 'shared/atoms/common/traffic';

export const UserOpenGraph = () => {
  const canonicalUrl = useAtomValue($SEOCurrentTraffic).canonicalUrl;
  const { title, description } = useUserTDK();
  const loadableUser = useAtomValue(loadable($CurrentAvailableUserOrNull));

  const getOGImageMeta: () => IOGImage | null = () => {
    if (loadableUser.state !== 'hasData' || !loadableUser.data) {
      return null;
    }
    return loadableUser.data.avatar
      ? {
          url: loadableUser.data.avatar,
        }
      : null;
  };

  const ogCardInfo: ICommonPageOGCardProps = {
    ogUrl: canonicalUrl,
    ogTitle: title,
    ogDescription: description,
    ogMediaMetaInfo: getOGImageMeta(),
    // Temperately set all card as OG Article type
    ogType: EOGType.Article,
  };
  return <CommonPageOGCard {...ogCardInfo} />;
};
